import {space} from './space';

export const sizes = {
  ...space,
};
